export default "__VITE_ASSET__DzeTIGd___"